/**
 * NegotiationMeter — 4-segment horizontal bar showing negotiation
 * relevance (low / moderate / strong / very_strong).
 */
const LEVELS = ["low", "moderate", "strong", "very_strong"];

export default function NegotiationMeter({ negotiation }) {
    if (!negotiation) return null;
    const idx = LEVELS.indexOf(negotiation.level);
    return (
        <div className="space-y-2" data-testid="negotiation-meter">
            <div className="flex items-baseline justify-between gap-3">
                <span className="text-[10px] uppercase tracking-[0.18em] text-bl-muted">
                    Negotiation relevance
                </span>
                <span className="text-sm font-semibold text-bl">{negotiation.label}</span>
            </div>
            <div className="flex gap-1.5">
                {LEVELS.map((lv, i) => {
                    const active = i <= idx;
                    return (
                        <div
                            key={lv}
                            className={`h-2 flex-1 rounded-full transition-colors ${
                                active
                                    ? i >= 2
                                        ? "bg-[var(--bl-teal)]"
                                        : "bg-[var(--bl-teal)]/55"
                                    : "bg-bl-border/40"
                            }`}
                        />
                    );
                })}
            </div>
            {negotiation.reasons?.length > 0 && (
                <ul className="space-y-1 pt-1 text-xs text-bl-muted">
                    {negotiation.reasons.slice(0, 3).map((r, i) => (
                        <li key={i} className="flex gap-2">
                            <span className="text-bl-teal">•</span>
                            <span>{r}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
